import _ from 'underscore';
import roles from 'constants/Roles';
import { AVAILABLE_TOOLS } from '../constants/AvailableTools';

const MDY = 'MM-DD-YYYY';
const DMY = 'DD-MM-YYYY';
const YMD = 'YYYY-MM-DD';

export const getDateFormat = team =>
  team && team.dateFormat ? team.dateFormat : MDY;
export const DateFormats = {
  MDY,
  DMY,
  YMD
};

export const getAvailableToolsLimit = team => {
  const { assignedEventTools = [] } = team || {};
  const tools = {};
  for (const product in AVAILABLE_TOOLS) {
    const toolName = AVAILABLE_TOOLS[product];
    const assignedTools = assignedEventTools.filter(
      ({ tool }) => tool === product
    );
    tools[toolName] = {
      assignedUsers: assignedTools.length
    };
  }
  return tools;
};

export const getEventRole = (eventId, { events }) => {
  const eventRole = _.find(
    events,
    eventRole => eventRole.event?.toString() === eventId?.toString()
  );

  //If there is no event role, it must be that the user is a team admin
  if (!eventRole) {
    return {
      role: roles.ReadOnly
    };
  }

  return eventRole;
};

export default {
  getDateFormat,
  DateFormats,
  getAvailableToolsLimit,
  getEventRole
};
